import React, { useMemo } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./portfolio.css";

import sentenceBuilderImage from "./Images/Sb1.jpg";

function Portfolio({ embedded = false }) {
  const smartEduckaUrl = useMemo(() => {
    if (process.env.REACT_APP_SMART_EDUCKA_URL) {
      return process.env.REACT_APP_SMART_EDUCKA_URL;
    }

    const { hostname, protocol } = window.location;
    const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";

    if (isLocalHost) {
      return "http://127.0.0.1:8001";
    }

    const rootHost = hostname.startsWith("www.") ? hostname.slice(4) : hostname;
    return `${protocol}//school.${rootHost}`;
  }, []);

  const shopUrl = useMemo(() => {
    if (process.env.REACT_APP_SHOP_URL) {
      return process.env.REACT_APP_SHOP_URL;
    }

    const { hostname, protocol } = window.location;
    const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";

    if (isLocalHost) {
      return "http://127.0.0.1:3001";
    }

    const rootHost = hostname.startsWith("www.") ? hostname.slice(4) : hostname;
    return `${protocol}//shop.${rootHost}`;
  }, []);

  const projects = [
    {
      title: "Smart-Educka",
      category: "Plateforme scolaire",
      description:
        "Solution de gestion scolaire pour digitaliser les inscriptions, les paiements, les notes, les bulletins et le pilotage administratif.",
      image: "/smart-educka-screen.png",
      url: smartEduckaUrl,
      cta: "Voir la plateforme",
      external: true,
    },
    {
      title: "Plateforme e-commerce",
      category: "Commerce en ligne",
      description:
        "Boutique web concue pour presenter les produits, gerer les commandes et accompagner la vente en ligne sur une base simple et evolutive.",
      image: "/home-cards/sites-web-ecommerce.avif",
      url: shopUrl,
      cta: "Visiter la boutique",
      external: true,
    },
    {
      title: "Samol Caisse",
      category: "Application web de caisse",
      description:
        "Application de caisse accessible sur le web, avec encaissement rapide, gestion du stock, tarifs clairs et acces direct a l'essai.",
      image: "/samol-caisse-app-preview.png",
      url: "/app/",
      cta: "Ouvrir l'application",
      external: true,
    },
    {
      title: "Sentence Builder",
      category: "Application mobile",
      description:
        "Application educative qui aide les apprenants a construire des phrases en anglais a travers des exercices simples, progressifs et ludiques.",
      image: sentenceBuilderImage,
      url: "https://play.google.com/store/apps/details?id=com.sbbymiessan_free",
      cta: "Voir l'application",
      external: true,
    },
  ];

  return (
    <div className="content-page realisations-page">
      {embedded ? null : <Header />}

      <main className="content-main realisations-shell">
        <section className="realisations-hero">
          <div className="realisations-hero-copy">
            <span className="realisations-kicker">Nos realisations</span>
            <h1>Des projets concrets deployes pour l'education, le commerce et les outils metier.</h1>
            <p>
              Voici une selection de solutions deja concues par Samol Technologies.
              Chaque projet repond a un besoin clair, avec une mise en oeuvre orientee usage,
              simplicite et resultats.
            </p>
          </div>

          <div className="realisations-hero-panel">
            <div className="realisations-stat">
              <strong>4</strong>
              <span>projets mis en avant</span>
            </div>
            <div className="realisations-stat">
              <strong>Web + mobile</strong>
              <span>solutions deployees selon le besoin</span>
            </div>
            <div className="realisations-stat">
              <strong>Education / PME</strong>
              <span>cas d'usage deja traites</span>
            </div>
          </div>
        </section>

        <section className="realisations-grid-section">
          <div className="realisations-grid">
            {projects.map((project) => (
              <article className="realisations-card" key={project.title}>
                <div className="realisations-card-media">
                  <img src={project.image} alt={project.title} loading="lazy" />
                </div>

                <div className="realisations-card-body">
                  <span className="realisations-chip">{project.category}</span>
                  <h2>{project.title}</h2>
                  <p>{project.description}</p>
                  <a
                    href={project.url}
                    className="realisations-btn"
                    target={project.external ? "_blank" : undefined}
                    rel={project.external ? "noreferrer" : undefined}
                  >
                    {project.cta}
                  </a>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="realisations-cta">
          <div className="realisations-cta-card">
            <h2>Vous voulez un projet du meme niveau pour votre organisation ?</h2>
            <p>
              Nous pouvons concevoir une solution adaptee a votre activite, a vos contraintes
              et a votre budget.
            </p>
            <a href="/contact" className="realisations-btn realisations-btn-secondary">
              Nous contacter
            </a>
          </div>
        </section>
      </main>

      {embedded ? null : <Footer />}
    </div>
  );
}

export default Portfolio;



